
import dictionaryService from '@/core/dictionary/dictionary.service';
import { defineComponent, Ref, ref } from 'vue';
import {
    Dialog,
    DialogDescription,
    DialogOverlay,
    DialogTitle,
    TransitionRoot,
    TransitionChild,
} from '@headlessui/vue';

export default defineComponent({
    name: 'BaseDialog',
    components: { Dialog, DialogOverlay, DialogTitle, DialogDescription, TransitionRoot, TransitionChild },
    inheritAttrs: false,
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
        description: {
            type: String,
            required: false,
            default: '',
        },
        cancelButton: {
            type: String,
            required: false,
            default: dictionaryService.get('global/generic/dialogcancelbuttontext'),
        },
        confirmButton: {
            type: String,
            required: false,
            default: dictionaryService.get('global/generic/dialogconfirmbuttontext'),
        },
        confirmMethod: {
            type: Function,
            required: false,
            default: null,
        },
        isOpen: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['update:isOpen', 'close', 'visible'],
    setup(props, { attrs, emit }) {
        const confirmButtonElementRef: Ref<HTMLElement | null> = ref(null);

        return {
            attrs,
            closeModal() {
                emit('update:isOpen', false);
                emit('close');
            },
            onDialogOpen(): void {
                emit('visible', true);
            },
            onDialogClosed(): void {
                emit('visible', false);
            },
            confirm(): void {
                props.confirmMethod && props.confirmMethod();
            },
            confirmButtonElementRef,
        };
    },
});
